import { getUrl, ROUTES } from "shared/api/urls";
import { SOCIAL_PROVIDERS } from "./constants";

export const getSocialUrl = (provider: SOCIAL_PROVIDERS, redirectTo: string) => {
    const qs = `isAjax=1&customer_id=&provider=${provider}&page=signin&redirectTo=${encodeURIComponent(
        redirectTo
    )}`;

    return `${getUrl(ROUTES.SOCIAL_AUTH)}?${qs}`;
};
